// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__MNIXz","tag":"styles_tag__3C_88"};